// The backend reports failures in a few shapes:
//   { message: "Validation failed", errors: { field: ["..."] } }
//   { message: "Internal server error.", error: "cURL error 7: ..." }
//   { message: ["...", "..."] }
// These helpers flatten any of them into something displayable.

export const extractErrorMessages = (error, fallback) => {
  const data = error?.response?.data;

  if (!data) {
    return [error?.message || fallback];
  }

  const fieldErrors = Object.values(data.errors || {})
    .flat()
    .filter(Boolean);

  if (fieldErrors.length) {
    return fieldErrors;
  }

  if (Array.isArray(data.message)) {
    const messages = data.message
      .map((entry) => entry?.message || entry)
      .filter(Boolean);

    if (messages.length) return messages;
  }

  if (data.error) {
    return [data.error];
  }

  return [data.message || fallback];
};

export const extractErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  const messages = extractErrorMessages(error, fallback);

  // Keep the summary line in front of the detail when the backend sends both,
  // without doubling up punctuation on summaries that already end in a stop.
  if (data?.message && !Array.isArray(data.message)) {
    const details = messages.filter((message) => message !== data.message);

    if (details.length) {
      const separator = /[.!?]$/.test(data.message.trim()) ? " " : ": ";
      return `${data.message}${separator}${details.join(" ")}`;
    }
  }

  return messages.join(" ");
};
